/**
 * Converts view names from camelCase/PascalCase to snake_case for API compatibility
 * @param view - The view name to convert (e.g., "UserDetails", "distributor-login")
 * @returns The converted view name in snake_case (e.g., "user_details", "distributor_login")
 */
export const convertViewName = (view: string): string => {
  // Convert camelCase or PascalCase to hyphenated lowercase
  return view
    .replace(/([a-z])([A-Z])/g, "$1_$2") // Convert camelCase to snake_case
    .replace(/([A-Z])([A-Z][a-z])/g, "$1_$2") // Handle consecutive capitals
    .toLowerCase()
    .replace(/-/g, "_"); // Replace any existing hyphens with underscores
};
